"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Link = _interopRequireDefault(require("../Link"));
var _spacing = _interopRequireDefault(require("../tokens/spacing"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _ChevronRight = _interopRequireDefault(require("../Icons/all/ChevronRight"));
var _colors = require("../tokens/colors");
var Breadcrumb = function Breadcrumb(props) {
  return /*#__PURE__*/_react["default"].createElement(Breadcrumb.Ele, (0, _extends2["default"])({
    "aria-label": "Breadcrumb"
  }, props), props.children);
};
Breadcrumb.Separator = _styledComponents["default"].div.withConfig({
  componentId: "sc-ukj373-0"
})(["margin-left:", ";color:", ";cursor:default;font-size:1.2rem;@media (max-width:480px){display:none;}"], _spacing["default"].xsmall, _grey["default"].z400);
Breadcrumb.Ele = _styledComponents["default"].div.withConfig({
  componentId: "sc-ukj373-1"
})(["span{font-size:1.2rem;}& > a{font-weight:300;color:", ";}& > a:visited:hover:not(last-child) > span{@media (min-width:481px){color:", ";}}& > a:first-child span{padding-left:0;border-left:0;}& > a:last-child{margin-right:0;color:", ";cursor:default;pointer-events:none;}& > a:last-child:visited span{color:", ";}& > a:last-child ", "{display:none;}& > a:first-child{color:", ";}@media (max-width:480px){display:flex;flex-direction:column;span{font-size:1.4rem;padding:0;border-bottom:1px solid ", ";border-radius:0;width:100%;padding:1.5rem 0;color:", " !important;}& > a:last-child span{color:", " !important;}}& > a:last-child i svg{fill:", ";}"], _grey["default"].z600, _colors.link.defaultHover, _grey["default"].z300, _grey["default"].z300, Breadcrumb.Separator, _colors.link.defaultColor, _grey["default"].z200, _grey["default"].z900, _grey["default"].z300, _grey["default"].z300);
Breadcrumb.Chevron = (0, _styledComponents["default"])(_ChevronRight["default"]).withConfig({
  componentId: "sc-ukj373-2"
})(["@media (min-width:481px){display:none !important;}"]);
var StyledLink = /*#__PURE__*/(0, _styledComponents["default"])(_Link["default"]).withConfig({
  componentId: "sc-ukj373-3"
})(["@media (max-width:480px){span{display:flex;justify-content:space-between;align-items:center;}}"]);
Breadcrumb.Link = function (props) {
  return /*#__PURE__*/_react["default"].createElement(StyledLink, (0, _extends2["default"])({}, props, {
    activeColor: _grey["default"].z600
  }), props.children, /*#__PURE__*/_react["default"].createElement(Breadcrumb.Separator, null, "/"), !!props.isMobile && /*#__PURE__*/_react["default"].createElement(Breadcrumb.Chevron, null));
};
Breadcrumb.propTypes = {
  children: _propTypes["default"].element.isRequired
};
Breadcrumb.Link.propTypes = {
  linkTo: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool
};
Breadcrumb.Link.defaultProps = {
  isMobile: true
};
var _default = exports["default"] = Breadcrumb;